if (!customElements.get('radio-dropdown')) {
    class RadioDropdown extends HTMLElement {
        fieldset = null;
        button = null;
        abortController = null;
        connectedCallback() {
            this.fieldset = this.querySelector('fieldset');
            this.button = this.querySelector('button');
            this.abortController = new AbortController();
            const signal = this.abortController.signal;
            this.addEventListener('mouseenter', this.onMouseEnter, { signal });
            this.addEventListener('mouseleave', this.onMouseLeave, { signal });
            this.addEventListener('focusin', this.onFocusIn, { signal });
            this.addEventListener('focusout', this.onFocusOut, { signal });
            if (this.fieldset && !this.fieldset.id) {
                this.fieldset.id = `radio-dropdown-${Math.random().toString(36).slice(2)}`;
            }
            if (this.button) {
                this.button.addEventListener('click', this.onButtonClick, { signal });
                this.button.setAttribute('aria-haspopup', 'true');
                this.button.setAttribute('aria-expanded', 'false');
                if (this.fieldset?.id) {
                    this.button.setAttribute('aria-controls', this.fieldset.id);
                }
            }
        }
        disconnectedCallback() {
            this.abortController?.abort();
            this.abortController = null;
        }
        open() {
            this.setAttribute('data-open', 'true');
            this.button?.setAttribute('aria-expanded', 'true');
        }
        close() {
            this.removeAttribute('data-open');
            this.button?.setAttribute('aria-expanded', 'false');
        }
        onButtonClick = (ev) => {
            const currState = this.getAttribute('data-open');
            if (currState === 'true') {
                this.setAttribute('data-open', 'false');
                this.button?.setAttribute('aria-expanded', 'false');
                return;
            }
            this.setAttribute('data-open', 'true');
            this.button?.setAttribute('aria-expanded', 'true');
            // Keyboard-initiated click (Space/Enter) -> MouseEvent.detail === 0 (detail is an attribute of UIEvent)
            if (ev.detail === 0) {
                const checkedRadio = this.querySelector('input[type="radio"]:checked');
                if (checkedRadio) {
                    checkedRadio.focus();
                }
                else {
                    const firstRadio = this.querySelector('input[type="radio"]');
                    firstRadio?.focus();
                }
            }
        };
        onMouseEnter = () => {
            this.open();
        };
        onMouseLeave = (event) => {
            const related = event.relatedTarget;
            if (!related || !this.contains(related)) {
                this.close();
            }
        };
        onFocusIn = () => {
            this.open();
        };
        onFocusOut = (event) => {
            const related = event.relatedTarget;
            if (!related || !this.contains(related)) {
                this.close();
            }
        };
    }
    customElements.define('radio-dropdown', RadioDropdown);
}
